import React from "react";
import { Link } from "react-router-dom";
import { Socials } from "../home";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen relative overflow-hidden mt-20">
      <div className="container mx-auto px-4 py-16 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          Refund Policy
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Introduction
          </h2>
          <p>
            At marketpulse.exchange, powered by Project Options™ - a
            SEBI-registered and trademarked entity - we are deeply committed to
            delivering high-quality tools, analytics, and trading intelligence
            to support our users in navigating the markets. Our goal is to
            empower traders with data-driven insights and technology to make
            informed decisions.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Please Read Carefully Before Subscribing
          </h2>
          <p>We want to be transparent and clear with all our users:</p>
          <p>
            While we provide intelligent analytics and signals based on rigorous
            quantitative and qualitative research, all trading and investment
            activities involve risk. Markets are inherently unpredictable, and
            we do not promise, assure, or guarantee any specific returns on
            trades, strategies, or recommendations.
          </p>

          <p>
            By subscribing to our services, users acknowledge and accept the
            inherent market risks and agree that:
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              No refund requests will be entertained under any circumstances -
              whether based on individual performance, expectations,
              dissatisfaction, or change of mind.
            </li>
            <li>
              Once a service is subscribed to and payment is made, the
              subscription is final, non-cancellable, and non-refundable.
            </li>
            <li>
              Market conditions, volatility, or outcomes of trades do not
              qualify for refunds or service reversals.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Why This Policy?
          </h2>
          <p>This strict no-refund policy ensures that we can:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Continue offering affordable, high-quality services at scale.
            </li>
            <li>
              Allocate our resources to improving features and support for
              committed users.
            </li>
            <li>
              Maintain fairness and integrity in how we operate, without
              exceptions.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Our Recommendation
          </h2>
          <p>We strongly recommend that all potential subscribers:</p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Carefully review all product details, service scope, disclaimers,
              disclosures, and terms before making any payment.
            </li>
            <li>
              Understand the nature of financial markets and the role our
              platform plays as an analytical aid - not a promise of profit.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Our Commitment
          </h2>
          <p>
            While we do not offer refunds, we are fully committed to
            continuously upgrading our tools, features, and user experience to
            maximize satisfaction for all our subscribers. We listen to
            feedback, act on it, and strive to deliver value through continuous
            innovation.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Final Note
          </h2>
          <p>
            By subscribing, you confirm that you have read, understood, and
            agreed to our Terms & Conditions, Disclaimers, and Refund Policy in
            full.
          </p>
          <p>
            For any queries before subscribing, feel free to reach out to our
            support team. We're here to help - but we do not offer refunds
            post-payment.
          </p>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Need Help?</h3>
            <p className="mb-6">
              Our support team is here to assist you with any questions before
              you subscribe.
            </p>
            <Socials />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
